import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import styles from './ChildCard.module.css';

const ChildInfoOnCard = ({ child, dropoffScreen = false }) => {
  return (
    <>
      <Box sx={{ textAlign: 'center', marginBottom: '2rem' }}>
        <img
          src='/assets/images/angel_halo.png'
          alt='hero girl'
          className={styles.angelHalo}
        />
      </Box>
      <Box className={styles.angelCardContent}>
        <Typography variant='h5' component='h5' gutterBottom>
          Hi, my name is{' '}
          <span className={styles.childFont}>{child.childName}</span>.
        </Typography>
        <Typography variant='h5' component='h5' gutterBottom>
          I am <span className={styles.childFont}>{child.age}</span> years old.
        </Typography>
        <Typography variant='h5' component='h5' gutterBottom>
          With your help, my wish can come true.
        </Typography>
        <Divider className={styles.angelCardDivider} />
        <Typography variant='h5' component='h5' gutterBottom>
          This season, I wish to get:
        </Typography>
        <Typography variant='h5' component='h5' gutterBottom>
          <span className={`${styles.childFont} ${styles.wishText}`}>
            {child.wish}
          </span>
        </Typography>

        {dropoffScreen && (
          <Typography  className={styles.childIdBadge} variant='h6' component='p'>
            {child.childId}
          </Typography>
        )}
      </Box>
    </>
  );
};

export default ChildInfoOnCard;
